import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa"; 
import styled from 'styled-components';


const GoBackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isSettingsOrigin = location.state?.returnTo === "settings";

  // ✅ Show only for setup subpages under connections
  const isConnectionsSubpage =
    location.pathname.startsWith("/repo-setup") ||
    location.pathname.startsWith("/figma-setup") ||
    location.pathname.startsWith("/group-setup") ||
    location.pathname.startsWith("/discord-setup") ||
    location.pathname.startsWith("/auth-setup");

  if (!isConnectionsSubpage) return null;

  return (
    <ButtonWrapper>
      <BackButton
        onClick={() =>
          navigate(
            isSettingsOrigin ? "/settings" : "/connections",
            isSettingsOrigin
              ? {
                  state: {
                    settingsHeaderMode: location.state?.settingsHeaderMode,
                    settingsHeaderVariant: location.state?.settingsHeaderVariant,
                    settingsCourseName: location.state?.settingsCourseName,
                    settingsGroupName: location.state?.settingsGroupName,
                  },
                }
              : undefined
          )
        }
      >
        <FaArrowLeft className="w-4 h-4" style={{ marginRight: "8px" }} />
        <span>{isSettingsOrigin ? "Back to Settings" : "Back to Connections"}</span>
      </BackButton>
    </ButtonWrapper>
  );
};

export default GoBackButton;

/* Styled Components */
const ButtonWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 4rem;
`;

const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  background-color: #fafafc;
  color: #333333;
  border: 3px solid rgba(0, 0, 0, 0.04);
  padding: 8px 14px;
  border-radius: 11px;
  font-family: "SF Pro Text", system-ui, -apple-system, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.29;
  letter-spacing: -0.224px;
  cursor: pointer;
  transition: transform 0.1s ease-in-out;

  &:active {
    transform: scale(0.95);
  }
`;
